import { useMutation } from '@tanstack/react-query';
import { UserAPI } from 'api/user';
export const useUpdateHubspotMutation = ()=>{
    return useMutation((payload)=>UserAPI.updateHubspot(payload));
};
